import { TargetLayer } from 'business/models/CustomModels';
import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import { LayerDTO, SeedLayerDetailsDTO, WellIngDTO } from 'business/models/Models';
import { LayerType } from 'utils/Global';
import {
  findWellsInLayer,
  createTargetLayer,
  updateDropByTargetLayer,
} from './GenerateCommon';
import { Compute } from './VolCalculator';

export function SeedLayerGenerate(docData: ExperimentDtoClient, lyr: LayerDTO) {
  let seedLayer: SeedLayerDetailsDTO;
  if (lyr.type != LayerType.Seed) {
    throw new Error('SeedLayerGenerate: Invalid Layer Type.');
  } else {
    seedLayer = lyr.layerDetail as SeedLayerDetailsDTO;
  }

  if (seedLayer === undefined || seedLayer.seedId === undefined) {
    return;
  }

  const layerWidth: number = lyr.width + 1;
  const layerHeight: number = lyr.height + 1;

  //ToDo : fix it?
  const wells: WellIngDTO[][] = findWellsInLayer(
    docData.plateDto,
    lyr,
    docData.containerRows,
    docData.containerCols,
  );

  for (let i = 0; i < layerHeight; i++) {
    for (let j = 0; j < layerWidth; j++) {
      const dropSeedVolume: number = ComputeVaryAlong(
        lyr,
        i,
        j,
        seedLayer.startSeedDropVolume,
        seedLayer.stopSeedDropVolume,
        seedLayer.seedDropVolumeVaryAlong,
      );

      const targetLayer: TargetLayer = createTargetLayer(lyr, wells[i][j]);
      targetLayer.volume = Number(dropSeedVolume ? dropSeedVolume.toFixed(3) : 0);
      targetLayer.waterVolume = 0;

      Compute(targetLayer, lyr, docData);

      const drop = updateDropByTargetLayer(lyr, targetLayer, wells[i][j]);
      drop.volume =
        Number(drop.volume.toFixed(3)) + Number(targetLayer.volume.toFixed(3));
      drop.waterVolume += targetLayer.waterVolume;
      drop.dropSeedVolume = Number(dropSeedVolume ? dropSeedVolume.toFixed(3) : 0);
      drop.seedID = seedLayer.seedId;
    }
  }
}

function ComputeVaryAlong(layer, wellRowIndex, wellColIndex, start, stop, varyAlong) {
  let layerRowWidth;
  let layerRowHeight;

  switch (varyAlong) {
    case 1: //None
      return start;
    case 2: //Row
      layerRowWidth = layer.width + 1;
      if (layerRowWidth == 1) {
        return start;
      }
      return start + ((stop - start) / (layerRowWidth - 1)) * wellColIndex;
    case 3: //Column
      layerRowHeight = layer.height + 1;
      if (layerRowHeight == 1) {
        return start;
      }
      return start + ((stop - start) / (layerRowHeight - 1)) * wellRowIndex;
    case 5: //Well Number
      layerRowWidth = layer.width + 1;
      layerRowHeight = layer.height + 1;
      if (layerRowHeight * layerRowWidth == 1) {
        return start;
      }
      return (
        start +
        ((stop - start) / (layerRowHeight * layerRowWidth - 1)) *
          (wellRowIndex * layerRowWidth + wellColIndex)
      );
    default:
      throw new Error('Unknown grid vary encountered.');
  }
}
